import type NewWord from '@/Models/NewWords/NewWord';
import { makeAutoObservable, observable } from 'mobx';

interface StateData {
    wordID: number;
    word: string;
    language: string;
    isOpen: boolean;
    error: string | undefined;
}

export default class NewWordsDetailStore {
    state: StateData;

    constructor() {
        makeAutoObservable(this, {
            state: observable,
        });

        this.state = {
            wordID: 0,
            word: '',
            language: 'NL',
            isOpen: false,
            error: undefined,
        };
    }

    setLanguage = (language: string): void => {
        this.state.language = language;
    };

    setWord = (word: string): void => {
        this.state.word = word;
    };

    setWordID = (wordID: number): void => {
        this.state.wordID = wordID;
    };

    setDialogIsOpen = (isOpen: boolean): void => {
        this.state.isOpen = isOpen;
        this.state.error = undefined;
    };

    setSelectedWord = (selectedWord: NewWord | undefined): void => {
        this.setWordID(selectedWord?.ID ?? 0);
        this.setLanguage(selectedWord?.Language ?? 'NL');
        this.setWord(selectedWord?.Word ?? '');
    };
}
